import React, {useEffect, useState} from 'react';
import '../App.css';
import {Button, Card, Col, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import '../style/style.css'
import {useCookies} from "react-cookie";
import {toast} from "react-toastify";
import {
    connectionErrorMessage,
    deleteAhtapotTenantSubscriptionUrl,
    errorMessage,
    getAhtapotSubscriptionPaymentDetailDtoUrl,
    get3AylikAhtapotSubscriptionPaymentDetailDtoUrl,
    checkReferenceCodeUrl,
    sendDiscountCouponCodeUrl, getAhtapotUpdateFileCountDtoUrl
} from "../data";
import moment from "moment";
import PaymentModal from "../ui/modal/PaymentModal";
import NumberFormat from "react-number-format";
import WarningDialog from "../ui/dialog/WarningDialog";
import EtcDataGrid from "../ui/grid/EtcDataGrid";
import AhtapotTextBox from "./AhtapotTextBox";
import AhtapotPlans from "../ui/AhtapotPlans";
import AhtapotWarningTextBox from "./AhtapotWarningTextBox";
import AhtapotOptionsPanel from "./AhtapotOptionsPanel";
import AhtapotOptionsInfoModal from "../ui/dialog/AhtapotOptionsInfoModal";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import PeopleAlt from "@mui/icons-material/PeopleAlt";
import SendIcon from "@mui/icons-material/Send";
import {GridRenderCellParams} from "@mui/x-data-grid";
import AhtapotUpdateFileCountFormDialog from "./AhtapotUpdateFileCountFormDialog";
import {debugLog} from "../debug";
import AhtapotAddFileCountFormDialog from "./AhtapotAddFileCountFormDialog";
import OnlinePaymentDisabledNotice, {
    ONLINE_PAYMENT_ENABLED,
    disabledPaymentButtonStyle
} from "../ui/OnlinePaymentDisabledNotice";

const columns = [
    {
        field: 'subscriptionBillingTypeEnumValue',
        headerName: 'Abonelik Tipi',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    },
    {
        field: 'validIntervalBeginDateTime',
        type: 'dateTime',
        headerName: 'Abonelik Başlangıç Tarihi',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    },
    {
        field: 'validIntervalEndDateTime',
        type: 'dateTime',
        headerName: 'Abonelik Bitiş Tarihi',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    },
    {
        field: 'expiryDayCount',
        headerName: 'Abonelik Bitiş Kalan Gün Sayısı',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    },
    {
        field: 'lastModifiedDateTime',
        type: 'dateTime',
        headerName: 'Son Değişiklik Tarihi',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    },
    {
        field: 'paymentAmountWithCommission',
        headerName: 'Ödenen Ücret',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        valueFormatter: ({ value }) => (value ? currencyFormatter.format(Number(value)) : null),
        flex: 1
    },
    {
        field: 'installmentIndex',
        headerName: 'Taksit Sayısı',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        renderCell: (params: GridRenderCellParams) => (
            <strong>
                {params.value > 1 ? (params.value) : "Tek Çekim"}
            </strong>
        ),
        flex: 1
    },
    {
        field: 'openUyapDosyaCount',
        headerName: 'Abonelik Dosya Sayısı',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    },
    {
        field: 'discountCouponName',
        headerName: 'Uygulanan Kampanya',
        headerAlign: 'center',
        headerClassName: 'cell-header',
        cellClassName: 'cell-data',
        flex: 1
    }
];

const currencyFormatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
});


function AhtapotSubscription(props) {
    const [cookies] = useCookies(['subscriptionToken']);
    const [ahtapotSubscriptionStatementList, setAhtapotSubscriptionStatementList] = React.useState([]);
    const [threeMonthTenantSubscriptionPaymentDetailDto, setThreeMonthTenantSubscriptionPaymentDetailDto] = React.useState([]);
    const [payAmount, setPayAmount] = useState(0);
    const [showPayModal, setShowPayModal] = useState(false);
    const [selectedAhtabotSubscriptionType, setSelectedAhtabotSubscriptionType] = useState('');
    const [ahtapotBillingCalculationDto, setAhtapotBillingCalculationDto] = useState(undefined);
    const [openWarningFormDialog, setOpenWarningFormDialog] = React.useState(false);
    const [openUpdateFileCountFormDialog, setOpenUpdateFileCountFormDialog] = React.useState(false);
    const [openAddFileCountFormDialog, setOpenAddFileCountFormDialog] = React.useState(false);
    const [selectedAhtapotAbonelikAktiflestirmeDto, setSelectedAhtapotAbonelikAktiflestirmeDto] = React.useState(undefined);
    const [ahtapotWarningOptionsModalOpen, setAhtapotWarningOptionsModalOpen] = useState(false);
    const [toggleDiscountCouponInput, setToggleDiscountCouponInput] = React.useState(false);
    const [toggleDiscountCouponInputType, setToggleDiscountCouponInputType] = React.useState("");
    const [discountCouponCodeValue, setDiscountCouponCodeValue] = React.useState("");
    // eslint-disable-next-line
    const [discountCouponCodeDto, setDiscountCouponCodeDto] = React.useState(null);
    const [referenceCodeMonthly, setReferenceCodeMonthly] = useState(null);
    const [referenceCodeYearly, setReferenceCodeYearly] = useState(null);
    const [referenceCodeValue, setReferenceCodeValue] = React.useState(null);
    // eslint-disable-next-line
    const [enableDiscountCodeSuccess, setEnableDiscountCodeSuccess] = React.useState(false);
    const [ahtapotUpdateFileCountDto, setAhtapotUpdateFileCountDto] = React.useState("");
    const [resetAddFileCountDialog, setResetAddFileCountDialog] = useState(false);
    const [addFileCountPaymentDialog, setAddFileCountPaymentDialog] = useState(false);

    useEffect(() => {
        if (!cookies.subscriptionToken) {
            toast.error(connectionErrorMessage, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(getAhtapotSubscriptionPaymentDetailDtoUrl,
            {
                headers: new Headers({'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                moment.locale('tr')

                for (var i = 0; i < data.length; i++) {

                    data[i].validIntervalEndDateTime = moment(data[i].validIntervalEndDateTime).format("LL");
                    data[i].validIntervalBeginDateTime = moment(data[i].validIntervalBeginDateTime).format("LLL");
                    data[i].lastModifiedDateTime = moment(data[i].lastModifiedDateTime).format("LLL");
                }

                setAhtapotSubscriptionStatementList(data);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

    }, [cookies.subscriptionToken]);


    useEffect(() => {
        if (!cookies.subscriptionToken) {
            toast.error(connectionErrorMessage, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(get3AylikAhtapotSubscriptionPaymentDetailDtoUrl,
            {
                headers: new Headers({'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                moment.locale('tr')

                setThreeMonthTenantSubscriptionPaymentDetailDto(data);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

    }, [cookies.subscriptionToken]);

    useEffect(() => {
        let amount = 0;
        setPayAmount(amount);
    }, []);

    const handleOpenWarningFormDialog = () => {
        setOpenWarningFormDialog(true);
    };

    const handleCloseWarningFormDialog = () => {
        setOpenWarningFormDialog(false);
    };

    const handleOpenUpdateFileCountFormDialog = () => {
        setOpenUpdateFileCountFormDialog(true);
    };

    const handleCloseUpdateFileCountFormDialog = () => {
        setOpenUpdateFileCountFormDialog(false);
    };


    const handleOpenAddFileCountFormDialog = () => {
        setOpenAddFileCountFormDialog(true);
    };

    const handleCloseAddFileCountFormDialog = () => {
        setResetAddFileCountDialog(true);
        setOpenAddFileCountFormDialog(false);
    };

    const handleOpenAddFileCountFormPaymentDialog = () => {
        setAddFileCountPaymentDialog(true);
    };

    const handleCloseAddFileCountFormPaymentDialog = () => {
        setAddFileCountPaymentDialog(false);
        window.location.reload();
    };


    const handleAcceptWarningFormDialog = () => {
        handleCloseWarningFormDialog();
        if (!props?.tenantSubscriptionViewDto) {
            toast.error("Geçersiz Kullanıcı", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        fetch(deleteAhtapotTenantSubscriptionUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify(props?.tenantSubscriptionViewDto)
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (data) {
                    if (data?.selectedAhtapotSubscriptionBillingTypeEnumValue === "PRESALE_DEMO") {
                        toast.success(<div className="center-text-toast"><p>AhtaBot Demo Üyeliğin Sonlandırma Talebiniz
                            alınmıştır.</p>
                            <button>Tamam</button>
                        </div>, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: false,
                            onClose: () => props?.refreshTab()
                        })
                    } else if (data?.selectedAhtapotSubscriptionBillingTypeEnumValue) {
                        toast.success(<div className="center-text-toast"><p>AhtaBot Üyeliği Sonlandırma Talebiniz Alınmıştır.</p>
                            <button>Tamam</button>
                        </div>, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: false,
                            onClose: () => props?.refreshTab()
                        })
                    } else {
                        if (data?.message === "NOT_FOUND_SUBSCRIPTION") {
                            toast.warn("Aktif Üyelik Bulunamadı!", {
                                position: toast.POSITION.TOP_CENTER
                            });
                        }
                    }

                }
            }, (error) => {
                if (error) {
                    toast.error("Işlemiz Hata Aldı!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const modalHandleOpenWith3Aylik = async () => {
        if ((referenceCodeValue === null || referenceCodeValue === '' || referenceCodeValue === ' ') &&
            referenceCodeMonthly != null && referenceCodeMonthly !== '' && referenceCodeMonthly !== ' ') {
            const referenceCodeValid = await checkReferenceCodeForOdemeYapButton('monthly');
            if (referenceCodeValid === false || !referenceCodeValid) {
                return;
            }
        }
        if (!enableDiscountCodeSuccess && props?.viewDto?.ahtapotThreeMonthDto!=null && threeMonthTenantSubscriptionPaymentDetailDto!=null && threeMonthTenantSubscriptionPaymentDetailDto?.id!=null) {
            toast.error("Daha önce 3 Aylık Tanışma Paketi satın almış olduğunuz kaydedilmiştir. " +
                "Aynı paketi tekrar satın almanız mümkün olmamaktadır. Yıllık Satın Alma Paketlerimizden birini seçebilirsiniz.", {
                position: toast.POSITION.TOP_CENTER
            });
        } else {
            if(enableDiscountCodeSuccess) {
                setSelectedAhtabotSubscriptionType(discountCouponCodeDto.subscriptionPresalePriceTitle);
                let selectedAhtapotBillingCalculationDto = {"discountCouponCodeDto":discountCouponCodeDto};
                setPayAmount(discountCouponCodeDto?.amountWithKDV);
                setAhtapotBillingCalculationDto(selectedAhtapotBillingCalculationDto)
                if (props?.tenantSubscriptionViewDto?.hasAhtapotSubscription) {
                    setShowPayModal(true);
                } else {
                    setAhtapotWarningOptionsModalOpen(true);
                }
            } else if (selectedAhtabotSubscriptionType) {
                let selectedAhtapotBillingCalculationDto = getSelected3AylikAhtabotSubscriptionBill().discountedTotalBillWithKDV > 0 ?
                    getSelected3AylikAhtabotSubscriptionBill() : getSelectedYillikAhtabotSubscriptionBill();
                setPayAmount(selectedAhtapotBillingCalculationDto?.discountedTotalBill);
                setAhtapotBillingCalculationDto(selectedAhtapotBillingCalculationDto)
                if (props?.tenantSubscriptionViewDto?.hasAhtapotSubscription) {
                    setShowPayModal(true);
                } else {
                    setAhtapotWarningOptionsModalOpen(true);
                }
            } else {
                toast.error("Ödenecek Fatura seçiniz!", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }
    };

    const modalHandleOpen = async () => {
        if ((referenceCodeValue === null || referenceCodeValue === '' || referenceCodeValue === ' ') &&
            referenceCodeYearly != null && referenceCodeYearly !== '' && referenceCodeYearly !== ' ') {
            const referenceCodeValid = await checkReferenceCodeForOdemeYapButton('yearly');
            if (referenceCodeValid === false || !referenceCodeValid) {
                return;
            }
        }
        if(enableDiscountCodeSuccess) {
            setSelectedAhtabotSubscriptionType(discountCouponCodeDto.subscriptionPresalePriceTitle);
            let selectedAhtapotBillingCalculationDto = {"discountCouponCodeDto":discountCouponCodeDto};
            setPayAmount(discountCouponCodeDto?.amountWithKDV);
            setAhtapotBillingCalculationDto(selectedAhtapotBillingCalculationDto)
            if (props?.tenantSubscriptionViewDto?.hasAhtapotSubscription) {
                setShowPayModal(true);
            } else {
                setAhtapotWarningOptionsModalOpen(true);
            }
        } else if (selectedAhtabotSubscriptionType) {
            let selectedAhtapotBillingCalculationDto = getSelected3AylikAhtabotSubscriptionBill().discountedTotalBillWithKDV > 0 ?
                getSelected3AylikAhtabotSubscriptionBill() : getSelectedYillikAhtabotSubscriptionBill();
            setPayAmount(selectedAhtapotBillingCalculationDto?.discountedTotalBillWithKDV);
            setAhtapotBillingCalculationDto(selectedAhtapotBillingCalculationDto)
            if(props?.tenantSubscriptionViewDto?.hasAhtapotSubscription){
                setShowPayModal(true);
            } else {
                setAhtapotWarningOptionsModalOpen(true);
            }
        } else {
            toast.error("Ödenecek Fatura seçiniz!", {
                position: toast.POSITION.TOP_CENTER
            });
        }
    };

    const closeShowPayModal = () => {
        setShowPayModal(false);
    }

    const onDeleteAhtapot = () => {
        handleOpenWarningFormDialog();
    }

    const addFileCount = () => {
        fetch(getAhtapotUpdateFileCountDtoUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(props?.tenantSubscriptionViewDto)
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setAhtapotUpdateFileCountDto(data);
                handleOpenAddFileCountFormDialog();
            }, (error) => {
                if (error) {
                    toast.error("Dosya Sayısı Eklenirken Hata Oluştu!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const onUpdateFileCount = () => {
        fetch(getAhtapotUpdateFileCountDtoUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(props?.tenantSubscriptionViewDto)
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setResetAddFileCountDialog(true);
                setAhtapotUpdateFileCountDto(data);
                handleOpenUpdateFileCountFormDialog();
            }, (error) => {
                if (error) {
                    toast.error("Dosya Güncellemede Sorun Oluştu!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    function createAhtapotGrid() {
        return <><Card style={{display: 'flex', height: "100%", paddingLeft: 2}}>
            <Card.Header style={{fontsize: 8, fontWeight: "bold"}}>Ahtabot Aktif Ödeme Bilgileri</Card.Header>
            <EtcDataGrid columns={columns} data={ahtapotSubscriptionStatementList}/>

            <Card.Footer style={{color: "red", fontsize: 8, paddingRight:0}}>
                <Row className="justify-content-end" style={{marginRight:24}} >
                    <Button variant="primary"
                            className="mr-2"
                            disabled={!props?.tenantSubscriptionViewDto?.hasAhtapotSubscription}
                            onClick={addFileCount}>Dosya Ekle</Button>
                    <Button variant="primary"
                            className="mr-2"
                            disabled={!props?.tenantSubscriptionViewDto?.hasAhtapotSubscription}
                            onClick={onUpdateFileCount}>Dosya Sayısı Güncelle</Button>
                    <Button variant="danger"
                            disabled={!props?.tenantSubscriptionViewDto?.hasAhtapotSubscription}
                            onClick={onDeleteAhtapot}>Üyelik Bitir</Button>
                </Row>
            </Card.Footer>
        </Card>
        </>;
    }


    const viewDto = props?.viewDto;
    const getSelected3AylikAhtabotSubscriptionBill = () => {
        if(enableDiscountCodeSuccess && toggleDiscountCouponInputType === "3AYLIK"){
            return { discountedTotalBillWithKDV: discountCouponCodeDto.amountWithKDV, kdvAmount : discountCouponCodeDto.kdv};
        }

        if(!selectedAhtabotSubscriptionType){
            return { discountedTotalBillWithKDV: "", kdvAmount : ""};
        }
        if (selectedAhtabotSubscriptionType === '3AYLIK_500') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotFirstPackFiles;
        } else if (selectedAhtabotSubscriptionType === '3AYLIK_1000') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotSecondPackFiles;
        } else if (selectedAhtabotSubscriptionType === '3AYLIK_2000') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotThirdPackFiles;
        } else if (selectedAhtabotSubscriptionType === '3AYLIK_3000') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotFourthPackFiles;
        }else if (selectedAhtabotSubscriptionType === '3AYLIK_4000') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotFifthPackFiles;
        }else if (selectedAhtabotSubscriptionType === '3AYLIK_5000') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotSixthPackFiles;
        }else if (selectedAhtabotSubscriptionType === '3AYLIK_7500') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotSeventhPackFiles;
        }else if (selectedAhtabotSubscriptionType === '3AYLIK_10000') {
            return viewDto?.ahtapotThreeMonthDto?.ahtapotEighthPackFiles;
        }else{
            return {discountedTotalBillWithKDV:"", kdvAmount : ""};
        }
    }

    const getSelectedYillikAhtabotSubscriptionBill = () => {
        if(enableDiscountCodeSuccess && toggleDiscountCouponInputType === "YILLIK"){
            return { discountedTotalBillWithKDV: discountCouponCodeDto.amountWithKDV, kdvAmount : discountCouponCodeDto.kdv};
        }

        if(!selectedAhtabotSubscriptionType){
            return { discountedTotalBillWithKDV: "", kdvAmount : ""};
        }

        if (selectedAhtabotSubscriptionType === 'YILLIK_500') {
            return viewDto?.ahtapotOneYearDto?.ahtapotFirstPackFiles;
        } else if (selectedAhtabotSubscriptionType === 'YILLIK_1000') {
            return viewDto?.ahtapotOneYearDto?.ahtapotSecondPackFiles;
        } else if (selectedAhtabotSubscriptionType === 'YILLIK_2000') {
            return viewDto?.ahtapotOneYearDto?.ahtapotThirdPackFiles;
        } else if (selectedAhtabotSubscriptionType === 'YILLIK_3000') {
            return viewDto?.ahtapotOneYearDto?.ahtapotFourthPackFiles;
        }else if (selectedAhtabotSubscriptionType === 'YILLIK_4000') {
            return viewDto?.ahtapotOneYearDto?.ahtapotFifthPackFiles;
        }else if (selectedAhtabotSubscriptionType === 'YILLIK_5000') {
            return viewDto?.ahtapotOneYearDto?.ahtapotSixthPackFiles;
        }else if (selectedAhtabotSubscriptionType === 'YILLIK_7500') {
            return viewDto?.ahtapotOneYearDto?.ahtapotSeventhPackFiles;
        }else if (selectedAhtabotSubscriptionType === 'YILLIK_10000') {
            return viewDto?.ahtapotOneYearDto?.ahtapotEighthPackFiles;
        } else{
            return {discountedTotalBillWithKDV:"", kdvAmount : ""};
        }
    }
    const onChangeDiscountCouponCodeInput = (type) => (event) => {
        setDiscountCouponCodeValue(event.target.value);
        setToggleDiscountCouponInputType(!toggleDiscountCouponInput ? type : "");
    };


    const sendDiscountCouponCode = () => {
        fetch(sendDiscountCouponCodeUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify({"code" : discountCouponCodeValue,"type" : "AHTAPOT"})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setDiscountCouponCodeDto(data);
                setToggleDiscountCouponInput(false);
                setEnableDiscountCodeSuccess(true);
            }, (error) => {
                if (error) {
                    toast.error("Geçersiz Kod", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
   };

    const checkReferenceCodeForOdemeYapButton = (subscriptionType) => {
        const localReferenceCodeValue = (subscriptionType === 'yearly'
            ? referenceCodeYearly
            : subscriptionType === 'monthly'
                ? referenceCodeMonthly
                : null);

        return new Promise((resolve, reject) => {
            fetch(checkReferenceCodeUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify({ "referenceCode": localReferenceCodeValue })
            })
                .then(res => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error(errorMessage);
                    }
                })
                .then(data => {
                    if (data === false) {
                        setReferenceCodeValue(null);
                        toast.error("Geçersiz Referans Kodu!", {
                            position: toast.POSITION.TOP_CENTER
                        });
                        resolve(false);
                    } else {
                        setReferenceCodeValue(localReferenceCodeValue);
                        if (subscriptionType === 'yearly') {
                            setReferenceCodeMonthly("");
                        }
                        if (subscriptionType === 'monthly') {
                            setReferenceCodeYearly("");
                        }
                        toast.success("Referans Kodu Başarıyla Uygulandı!", {
                            position: toast.POSITION.BOTTOM_CENTER
                        });
                        resolve(true);
                    }
                })
                .catch(error => {
                    setReferenceCodeValue(null);
                    toast.error("Geçersiz Referans Kodu!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                    resolve(false);
                });
        });
    };

    const checkReferenceCode = (subscriptionType) => {
        const localReferenceCodeValue = (subscriptionType === 'yearly'
            ? referenceCodeYearly
            : subscriptionType === 'monthly'
                ? referenceCodeMonthly
                : null);

        return () => {
            fetch(checkReferenceCodeUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify({ "referenceCode": localReferenceCodeValue})
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {

                    throw new Error(errorMessage);
                }
            })
            .then(data => {
                if (data === false) {
                    setReferenceCodeValue(null);
                    toast.error("Geçersiz Referans Kodu!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }else{
                    setReferenceCodeValue(localReferenceCodeValue);
                    if(subscriptionType === 'yearly'){
                        setReferenceCodeMonthly("")
                    }
                    if(subscriptionType === 'monthly'){
                        setReferenceCodeYearly("")
                    }
                    toast.success("Referans Kodu Başarıyla Uygulandı!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            })
            .catch(error => {
                setReferenceCodeValue(null);
                toast.error("Geçersiz Referans Kodu!", {
                    position: toast.POSITION.TOP_CENTER
                });
            });
        };
    };

    return (
        <div  className="p-1">
            <Row>
                {(!props?.tenantSubscriptionViewDto?.hasAhtapotSubscription ||
                    props?.tenantSubscriptionViewDto?.selectedAhtapotSubscriptionBillingTypeEnumValue === "PRESALE_DEMO") ? <>
                        <Row style={{paddingLeft: "5px"}}>
                            <Col xs lg={(props?.tenantSubscriptionViewDto?.hasAhtapotSubscription &&
                                props?.tenantSubscriptionViewDto?.selectedAhtapotSubscriptionBillingTypeEnumValue !== "PRESALE_DEMO") ? 5 : 8}>
                                <AhtapotTextBox/>
                            </Col>
                        </Row>
                        <Row style={{paddingLeft: "10px"}}>
                            <AhtapotOptionsPanel
                                cookies={cookies}
                                selectedOption={selectedAhtapotAbonelikAktiflestirmeDto}
                                setSelectedOption={setSelectedAhtapotAbonelikAktiflestirmeDto}
                            />
                        </Row>
                    </> :
                    <Col style={{height: "250px"}}>
                        {(props?.tenantSubscriptionViewDto?.hasAhtapotSubscription &&
                            props?.tenantSubscriptionViewDto?.selectedAhtapotSubscriptionBillingTypeEnumValue !== "PRESALE_DEMO") ? createAhtapotGrid() : ""}
                        {props?.admin ? <Col>
                            <Button variant="danger"
                                    disabled={!props?.tenantSubscriptionViewDto?.hasAhtapotSubscription}
                                    onClick={onDeleteAhtapot}>Üyelik Bitir</Button>
                        </Col> : <>

                        </>}
                    </Col>}
                <WarningDialog
                    openDialog={openWarningFormDialog}
                    handleAcceptDialog={handleAcceptWarningFormDialog}
                    handleCloseDialog={handleCloseWarningFormDialog}
                    color={'red'}
                    title={"Üyelik Bitir"}
                    dialogContentText={"Mevcut Üyeliğiniz Sonlandırılacaktır, Devam Etmek İstiyor Musunuz?"}
                />
                <AhtapotAddFileCountFormDialog
                    ahtapotUpdateFileCountDto={ahtapotUpdateFileCountDto}
                    resetAddFileCountDialog={resetAddFileCountDialog}
                    ownerTenantId={props?.tenantSubscriptionViewDto?.ownerTenantId}
                    openDialog={openAddFileCountFormDialog}
                    handleCloseDialog={handleCloseAddFileCountFormDialog}
                    paymentModalState={addFileCountPaymentDialog}
                    paymentModalOpen={handleOpenAddFileCountFormPaymentDialog}
                    paymentModalClose={handleCloseAddFileCountFormPaymentDialog}
                    refreshTab={() => {window.location.reload();}}
                    color={'blue'}
                    title={"Dosya Ekle"}
                />
                <AhtapotUpdateFileCountFormDialog
                    ahtapotUpdateFileCountDto={ahtapotUpdateFileCountDto}
                    openDialog={openUpdateFileCountFormDialog}
                    handleCloseDialog={handleCloseUpdateFileCountFormDialog}
                    refreshTab={() => {
                        window.location.reload();
                    }}
                    color={'blue'}
                    title={"Dosya Sayısı Güncelle"}
                />
            </Row>
            <div className="p-2">
                <h4 className="text-center font-weight-bold"
                    style={{color: 'darkblue'}}> {"3 Aylık Tanışma Paketi"} </h4>
                <hr/>
                <AhtapotPlans ahtapotPeriodDto={props?.viewDto?.ahtapotThreeMonthDto} type="3AYLIK"
                              enableCheckBoxIcon={true}
                              selectedEnumValue={selectedAhtabotSubscriptionType}
                              setSelectedEnumValue={setSelectedAhtabotSubscriptionType}/>

                <Row className="justify-content-end" >
                    {toggleDiscountCouponInputType !== "YILLIK" &&   <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingRight: 110,
                        paddingBottom: 6
                    }}>
                        <CardGiftcardIcon
                            fontSize='large'
                            // eslint-disable-next-line
                            color={enableDiscountCodeSuccess ? "success" : "warning"}
                        />
                        {(!enableDiscountCodeSuccess) && (
                            <>
                                <FormControl
                                    onChange={onChangeDiscountCouponCodeInput("3AYLIK")}
                                    value={discountCouponCodeValue}
                                    style={{ width: '160px' }}
                                    placeholder="Kampanya Kodu"
                                    type='text'
                                />
                                <SendIcon fontSize='large' onClick={() => {
                                    sendDiscountCouponCode();
                                    setToggleDiscountCouponInput(!toggleDiscountCouponInput);
                                    setToggleDiscountCouponInputType(!toggleDiscountCouponInput ? "3AYLIK" : "");
                                }}
                                color={"success"}/>
                            </>
                        )}
                        {enableDiscountCodeSuccess && (
                            <button style={{
                                backgroundColor: '#04AA6D',
                                border: 'none',
                                color: 'white',
                                textAlign: 'center',
                                marginRight: '45px',
                                textDecoration: 'none',
                                display: ' inline-block',
                                borderRadius: '40%'
                            }}>
                                {discountCouponCodeDto &&
                                    discountCouponCodeDto.subscriptionPresalePriceTitle}
                            </button>
                        )}
                    </div>}
                </Row>
                <Row className="justify-content-end" >
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: 110,paddingBottom: 6}}>
                        <PeopleAlt fontSize='large'
                                   color={referenceCodeMonthly != null && referenceCodeMonthly !== '' && referenceCodeValue != null && referenceCodeValue !== '' ? "success" : "warning"} />
                        <FormControl
                            type='text'
                            placeholder='Referans Kodu'
                            value={referenceCodeMonthly}
                            onChange={(e) => {setReferenceCodeMonthly(e.target.value);
                            setReferenceCodeValue('');
                            setReferenceCodeYearly('');
                            }}
                            style={{ width: '160px' }}
                        />
                        <SendIcon
                            fontSize='large'
                            color={referenceCodeMonthly != null && referenceCodeMonthly !== '' && referenceCodeValue != null && referenceCodeValue !== '' ? "success" : "warning"}
                            onClick={checkReferenceCode("monthly")}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </Row>
                <Row className="justify-content-end">
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: 10, paddingRight: 145}}>
                            <Form.Label
                                style={{minWidth: '150px', textAlign: 'end', marginRight: '10px', fontWeight: '600'}}>KDV
                                Tutarı:</Form.Label>
                            <InputGroup>
                                <NumberFormat
                                    value={getSelected3AylikAhtabotSubscriptionBill()?.kdvAmount}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    renderText={value =>
                                        <Form.Control
                                            type='text'
                                            style={{
                                                "textAlign": "end",
                                                "verticalAlign": "middle",
                                                "maxWidth": 120
                                            }}
                                            value={value}
                                            disabled={true}
                                        />}
                                />
                                <InputGroup.Append>
                                    <InputGroup.Text>TL</InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                </Row>
                <Row className="justify-content-end">
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: 10}}>
                            <Form.Label
                                style={{minWidth: '300px', textAlign: 'end', marginRight: '10px', fontWeight: '600'}}>KDV
                                Dahil Toplam Tutar:</Form.Label>
                            <InputGroup>
                                <NumberFormat
                                    value={getSelected3AylikAhtabotSubscriptionBill()?.discountedTotalBillWithKDV}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    renderText={value =>
                                        <Form.Control
                                            type='text'
                                            style={{
                                                "textAlign": "end",
                                                "verticalAlign": "middle",
                                                "maxWidth": 120
                                            }}
                                            value={value}
                                            disabled={true}
                                        />}
                                />
                                <InputGroup.Append>
                                    <InputGroup.Text>TL</InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="pl-2" style={{marginRight:30}}>
                        <Button
                            variant={!ONLINE_PAYMENT_ENABLED ? "secondary" : "primary"}
                            disabled={!ONLINE_PAYMENT_ENABLED || !getSelected3AylikAhtabotSubscriptionBill()?.discountedTotalBillWithKDV}
                            style={!ONLINE_PAYMENT_ENABLED ? disabledPaymentButtonStyle : undefined}
                            onClick={ONLINE_PAYMENT_ENABLED ? modalHandleOpenWith3Aylik : undefined}
                        >
                            Ödeme Yap
                        </Button>
                    </div>
                </Row>
                <Row className="justify-content-end">
                    <div style={{marginRight: 30, marginBottom: 8, maxWidth: 520}}>
                        <OnlinePaymentDisabledNotice style={{marginTop: 0}}/>
                    </div>
                </Row>
                <h4 className="text-center font-weight-bold"
                    style={{color: 'darkblue'}}> {"İndirimli Yıllık Paket"} </h4>
                <hr/>
                <AhtapotPlans ahtapotPeriodDto={props?.viewDto?.ahtapotOneYearDto} type="YILLIK"
                              enableCheckBoxIcon={true}
                              selectedEnumValue={selectedAhtabotSubscriptionType}
                              setSelectedEnumValue={setSelectedAhtabotSubscriptionType}/>
                <Row className="justify-content-end" >
                    {toggleDiscountCouponInputType !== "3AYLIK" && <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingRight: 110,
                        paddingBottom: 6
                    }}>
                        <CardGiftcardIcon
                            fontSize='large'
                            // eslint-disable-next-line
                            color={enableDiscountCodeSuccess ? "success" : "warning"}
                        />
                        {(!enableDiscountCodeSuccess) && (
                            <>
                                <FormControl
                                    onChange={onChangeDiscountCouponCodeInput("YILLIK")}
                                    value={discountCouponCodeValue}
                                    style={{ width: '160px' }}
                                    placeholder="Kampanya Kodu"
                                    type='text'
                                />
                                <SendIcon fontSize='large' onClick={() => {
                                    sendDiscountCouponCode();
                                    setToggleDiscountCouponInput(!toggleDiscountCouponInput);
                                    setToggleDiscountCouponInputType(!toggleDiscountCouponInput ? "YILLIK" : "");
                                }}
                                color={"success"}/>
                            </>
                        )}
                        {enableDiscountCodeSuccess && (
                            <button style={{
                                backgroundColor: '#04AA6D',
                                border: 'none',
                                color: 'white',
                                marginRight: '45px',
                                textAlign: 'center',
                                textDecoration: 'none',
                                display: ' inline-block',
                                borderRadius: '40%'
                            }}>
                                {discountCouponCodeDto &&
                                    discountCouponCodeDto.subscriptionPresalePriceTitle}
                            </button>
                        )}
                    </div>}
                </Row>
                <Row className="justify-content-end" >
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: 110, paddingBottom: 6}}>
                        <PeopleAlt fontSize='large'
                                   color={referenceCodeYearly != null && referenceCodeYearly !== '' && referenceCodeValue != null && referenceCodeValue !== '' ? "success" : "warning"} />
                        <FormControl
                            type='text'
                            placeholder='Referans Kodu'
                            value={referenceCodeYearly}
                            onChange={(e) => {setReferenceCodeYearly(e.target.value);
                                setReferenceCodeValue('');
                                setReferenceCodeMonthly('');
                            }}
                            style={{ width: '160px' }}
                        />
                        <SendIcon
                            fontSize='large'
                            color={referenceCodeYearly != null && referenceCodeYearly !== '' && referenceCodeValue != null && referenceCodeValue !== '' ? "success" : "warning"}
                            onClick={checkReferenceCode('yearly')}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </Row>
                <Row className="justify-content-end">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, paddingRight:145 }}>
                            <Form.Label style={{ minWidth: '150px', textAlign:'end', marginRight: '10px',fontWeight: '600' }}>KDV Tutarı:</Form.Label>
                            <InputGroup>
                                <NumberFormat
                                    value={getSelectedYillikAhtabotSubscriptionBill()?.kdvAmount}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    renderText={value =>
                                        <Form.Control
                                            type='text'
                                            style={{
                                                "textAlign": "end",
                                                "verticalAlign": "middle",
                                                "maxWidth": 120
                                            }}
                                            value={value}
                                            disabled={true}
                                        />}
                                />
                                <InputGroup.Append>
                                    <InputGroup.Text>TL</InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                </Row>
                <Row className="justify-content-end">
                    <div style={{ display: 'flex', flexDirection: 'column'}}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                            <Form.Label style={{ minWidth: '300px',textAlign:'end', marginRight: '10px', fontWeight: '600' }}>KDV Dahil Toplam Tutar:</Form.Label>
                            <InputGroup>
                                <NumberFormat
                                    value={getSelectedYillikAhtabotSubscriptionBill()?.discountedTotalBillWithKDV}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    renderText={value =>
                                        <Form.Control
                                            type='text'
                                            style={{
                                                "textAlign": "end",
                                                "verticalAlign": "middle",
                                                "maxWidth": 120
                                            }}
                                            value={value}
                                            disabled={true}
                                        />}
                                />
                                <InputGroup.Append>
                                    <InputGroup.Text>TL</InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="pl-2" style={{marginRight:30}}>
                        <Button
                            variant={!ONLINE_PAYMENT_ENABLED ? "secondary" : "primary"}
                            disabled={!ONLINE_PAYMENT_ENABLED || !getSelectedYillikAhtabotSubscriptionBill()?.discountedTotalBillWithKDV}
                            style={!ONLINE_PAYMENT_ENABLED ? disabledPaymentButtonStyle : undefined}
                            onClick={ONLINE_PAYMENT_ENABLED ? modalHandleOpen : undefined}
                        >
                            Ödeme Yap
                        </Button>
                    </div>
                </Row>
                <Row className="justify-content-end">
                    <div style={{marginRight: 30, marginBottom: 8, maxWidth: 520}}>
                        <OnlinePaymentDisabledNotice style={{marginTop: 0}}/>
                    </div>
                </Row>
                <AhtapotWarningTextBox/>
            </div>
            <PaymentModal payAmount={payAmount}
                          request={{ahtapotBillingCalculationDto: ahtapotBillingCalculationDto,
                              subscriptionPaymentMethodEnumValue: 'CREDIT_CARD',
                              referenceCode: referenceCodeValue,
                              ahtapotAbonelikAktiflestirmeDto:selectedAhtapotAbonelikAktiflestirmeDto}}
                          type={selectedAhtabotSubscriptionType} showModal={showPayModal}
                          close={closeShowPayModal}
                          cookies={cookies}/>
            <AhtapotOptionsInfoModal
                handleAcceptDialog={() => {setAhtapotWarningOptionsModalOpen(false);setShowPayModal(true)}}
                open={ahtapotWarningOptionsModalOpen}
                handleClose={() => setAhtapotWarningOptionsModalOpen(false)}
                ahtapotAbonelikAktiflestirmeDto={selectedAhtapotAbonelikAktiflestirmeDto}
            />
        </div>
    )
}

export default AhtapotSubscription;